

//Data imports
import AccessMatrix from '@/router/access-matrix';

//View and component imports
import RouteListItem_Contractlists from "@/components/SingleUse/ComponentOverrides/sidebar/RouteListItem_ContractLists.vue";
import PlannedConstruction from '@/views/landingpages/PlannedConstruction.vue';
const OldGuiFrame = () => import('@/views/landingpages/OldGuiFrame.vue')
const IsProd = (process.env.NODE_ENV === 'production');

const AgreementsContainerView = () => import('@/views/contracts/AgreementsContainerView.vue')
const NextOrders = OldGuiFrame;
const Contracts = IsProd ? OldGuiFrame : () => import('@/views/contracts/AdminContractList.vue')
const ServiceAgreements = IsProd ? PlannedConstruction : () => import('@/views/admin/machines/AdminServiceAgreements.vue');

//Export item
const trunk = {
  meta: {
    licenceEnabled: "Contract",
    authorize: AccessMatrix.ContractsTrunk.module,
    display: { key: "servicesystem.pages.page_titles.sales" },
    icon: "mdi-file-delimited",
  },
  path: '/agreements',
  name: 'agreements',
  component: AgreementsContainerView,
  redirect: { name: 'NextOrders' },
  children: [
    {
      meta: {
        authorize: AccessMatrix.ContractsTrunk.module,
        display: { key: "servicesystem.pages.page_titles.admin_service_agreements" },
        icon: "mdi-file-clock",
      },
      path: 'service-agreements',
      name: 'ServiceAgreements',
      component: ServiceAgreements,
    },

    {
      meta: {
        authorize: AccessMatrix.ContractsTrunk.module,
        display: { key: "servicesystem.pages.page_titles.contracts" },
        icon: "mdi-receipt-text-clock",
        overrides: {
          sidebar: RouteListItem_Contractlists,
        }
      },
      path: 'contracts/:contractTypeId',
      name: 'Contracts',
      component: Contracts,
    },

    {
      meta: {
        authorize: AccessMatrix.ContractsTrunk.module,
        displayName: 'Next order overview',
        icon: "mdi-receipt-clock",
      },
      path: 'next-orders',
      name: 'NextOrders',
      component: NextOrders,
    },
  ],
};

export default trunk;